import { useCallback } from 'react'
import { shellLayout } from '../lib/shellLayout'

// Shared by the docked shell's panels and the event graph's MY BLUEPRINT
// rail: every width it drags lives in shellLayout, which clamps and persists.

// ── Resize handles ────────────────────────────────────────────────────────────

/**
 * 5px drag handle. `axis` 'x' resizes a width, 'y' a height; `invert` flips the
 * delta for handles whose panel grows toward the drag origin (inspector, dock).
 */
export function ResizeHandle({ axis, storeKey, invert = false, disabled = false }) {
  const onPointerDown = useCallback((e) => {
    if (disabled) return
    e.preventDefault()
    const start = axis === 'x' ? e.clientX : e.clientY
    const base = shellLayout.getState()[storeKey]
    const move = (ev) => {
      const now = axis === 'x' ? ev.clientX : ev.clientY
      const delta = (now - start) * (invert ? -1 : 1)
      shellLayout.setState({ [storeKey]: base + delta })
    }
    const up = () => {
      window.removeEventListener('pointermove', move)
      window.removeEventListener('pointerup', up)
    }
    window.addEventListener('pointermove', move)
    window.addEventListener('pointerup', up)
  }, [axis, storeKey, invert, disabled])

  return (
    <div
      data-testid={`shell-resize-${storeKey}`}
      onPointerDown={onPointerDown}
      style={{
        flex: 'none',
        [axis === 'x' ? 'width' : 'height']: 5,
        background: 'var(--m-line)',
        cursor: disabled ? 'default' : axis === 'x' ? 'col-resize' : 'row-resize',
        touchAction: 'none',
      }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = 'var(--m-accent)' }}
      onMouseLeave={e => { e.currentTarget.style.background = 'var(--m-line)' }}
    />
  )
}
